import { User, Briefcase, Mail, Phone, MapPin, Calendar } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { cn } from '@/lib/utils';
import { AsyncState } from '@/components/ui/AsyncState';
import type { Account } from '@/models/account/types';
import type { AccountSearch } from '@/models/clients/types';

type Props = {
  account: Account | null;
  accountSearch: AccountSearch | undefined;
  isLoading: boolean;
  error: string | null;
};

export function GeneralInfoTab({ account, accountSearch, isLoading, error }: Props) {
  return (
    <div className='space-y-3'>
      <AsyncState isLoading={isLoading} error={error} loadingVariant='inline'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
          {[
            {
              icon: <User className='w-4 h-4' />,
              label: 'Логин',
              value: account?.login ?? accountSearch?.login ?? '—',
              mono: true,
            },
            {
              icon: <Briefcase className='w-4 h-4' />,
              label: 'Договор №',
              value: account?.dog_num || '—',
              mono: true,
            },
            { icon: <Mail className='w-4 h-4' />, label: 'Email', value: account?.email || '—' },
            {
              icon: <Phone className='w-4 h-4' />,
              label: 'Телефон',
              value: account?.phone_number || '—',
            },
            {
              icon: <User className='w-4 h-4' />,
              label: 'Менеджер',
              value: account?.manager_name?.trim() || '—',
            },
            {
              icon: <MapPin className='w-4 h-4' />,
              label: 'Адрес',
              value: account?.address || '—',
            },
            {
              icon: <Calendar className='w-4 h-4' />,
              label: 'Дата регистрации',
              value: account?.registration_date
                ? format(parseISO(account.registration_date), 'dd.MM.yyyy')
                : '—',
            },
          ].map((item) => (
            <div
              key={item.label}
              className='flex items-center gap-3 p-3.5 bg-muted/30 border border-border/30 rounded-xl'
            >
              <span className='text-muted-foreground shrink-0'>{item.icon}</span>
              <div className='min-w-0'>
                <p className='text-xs text-muted-foreground'>{item.label}</p>
                <p className={cn('text-sm text-foreground truncate', item.mono && 'font-mono')}>
                  {item.value}
                </p>
              </div>
            </div>
          ))}
        </div>
      </AsyncState>
    </div>
  );
}
